type IconExportsProps = {
  color?: string;
};

export const UserOutline: React.FC<IconExportsProps> = ({
  color,
}: IconExportsProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2137 21.3752C23.6576 20.0654 22.8507 18.8757 21.8378 17.8723C20.8281 16.866 19.6319 16.0637 18.3154 15.5096C18.3036 15.5038 18.2918 15.5008 18.28 15.495C20.1164 14.1759 21.3102 12.0272 21.3102 9.60301C21.3102 5.5871 18.0383 2.33333 14 2.33333C9.96164 2.33333 6.68972 5.5871 6.68972 9.60301C6.68972 12.0272 7.88353 14.1759 9.71993 15.4979C9.70814 15.5038 9.69635 15.5067 9.68456 15.5126C8.364 16.0666 7.17904 16.861 6.16209 17.8752C5.15018 18.8794 4.34339 20.0689 3.78626 21.3781C3.23895 22.6599 2.94377 24.034 2.9167 25.4263C2.91591 25.4576 2.92143 25.4887 2.93293 25.5178C2.94443 25.547 2.96167 25.5735 2.98365 25.5959C3.00562 25.6183 3.03189 25.6361 3.06089 25.6483C3.08989 25.6604 3.12104 25.6667 3.15251 25.6667H4.92112C5.05082 25.6667 5.15399 25.5641 5.15693 25.438C5.21589 23.175 6.12967 21.0557 7.74499 19.4493C9.41632 17.7873 11.6359 16.8727 14 16.8727C16.364 16.8727 18.5836 17.7873 20.2549 19.4493C21.8703 21.0557 22.784 23.175 22.843 25.438C22.8459 25.567 22.9491 25.6667 23.0788 25.6667H24.8474C24.8789 25.6667 24.91 25.6604 24.939 25.6483C24.968 25.6361 24.9943 25.6183 25.0163 25.5959C25.0382 25.5735 25.0555 25.547 25.067 25.5178C25.0785 25.4887 25.084 25.4576 25.0832 25.4263C25.0537 24.0251 24.7619 22.6621 24.2137 21.3752ZM14 14.6449C12.647 14.6449 11.3736 14.1202 10.4156 13.1675C9.45759 12.2148 8.92996 10.9485 8.92996 9.60301C8.92996 8.25753 9.45759 6.9912 10.4156 6.03852C11.3736 5.08584 12.647 4.56113 14 4.56113C15.3529 4.56113 16.6263 5.08584 17.5843 6.03852C18.5423 6.9912 19.07 8.25753 19.07 9.60301C19.07 10.9485 18.5423 12.2148 17.5843 13.1675C16.6263 14.1202 15.3529 14.6449 14 14.6449Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};

export const UserFilled: React.FC<IconExportsProps> = ({
  color,
}: IconExportsProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8378 17.8723C22.8507 18.8757 23.6576 20.0654 24.2137 21.3752C24.7619 22.6621 25.0537 24.0251 25.0832 25.4263C25.084 25.4576 25.0785 25.4887 25.067 25.5178C25.0555 25.547 25.0382 25.5735 25.0163 25.5959C24.9943 25.6183 24.968 25.6361 24.939 25.6483C24.91 25.6604 24.8789 25.6667 24.8474 25.6667H23.0788H4.5H3.15251C3.12104 25.6667 3.08989 25.6604 3.06089 25.6483C3.03189 25.6361 3.00562 25.6183 2.98365 25.5959C2.96167 25.5735 2.94443 25.547 2.93293 25.5178C2.92143 25.4887 2.91591 25.4576 2.9167 25.4263C2.94377 24.034 3.23895 22.6599 3.78626 21.3781C4.34339 20.0689 5.15018 18.8794 6.16209 17.8752C7.17904 16.861 8.36401 16.0666 9.68456 15.5126C9.69635 15.5067 9.70814 15.5038 9.71994 15.4979C7.88353 14.1759 6.68972 12.0272 6.68972 9.60301C6.68972 5.5871 9.96165 2.33333 14 2.33333C18.0383 2.33333 21.3102 5.5871 21.3102 9.60301C21.3102 12.0272 20.1164 14.1759 18.28 15.495C18.2918 15.5008 18.3036 15.5038 18.3154 15.5096C19.6319 16.0637 20.8281 16.866 21.8378 17.8723Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};

export const CartOutline: React.FC<IconExportsProps> = ({
  color,
}: IconExportsProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.17774 4.57334H4.35725L8.10277 20.1747C8.21975 20.662 8.60935 21 9.05395 21H20.8849C21.3373 21 21.7317 20.6502 21.8414 20.1516L24.4705 8.20498C24.5441 7.87039 24.478 7.51592 24.2911 7.24408C24.1043 6.97224 23.8176 6.81334 23.514 6.81334H6.93887L6.06146 3.15865C5.94448 2.67138 5.55489 2.33334 5.11029 2.33334H2.17774C1.61932 2.33334 1.16663 2.83478 1.16663 3.45334C1.16663 4.0719 1.61932 4.57334 2.17774 4.57334ZM8.37293 12.7867L7.47664 9.05334H22.2513L21.4297 12.7867H8.37293ZM8.9107 15.0267H20.9367L20.1152 18.76H9.80699L8.9107 15.0267ZM8.87496 25.6668C9.91049 25.6668 10.75 24.8563 10.75 23.8565C10.75 22.8567 9.91049 22.0462 8.87496 22.0462C7.83943 22.0462 6.99996 22.8567 6.99996 23.8565C6.99996 24.8563 7.83943 25.6668 8.87496 25.6668ZM23.1666 23.8565C23.1666 24.8563 22.3272 25.6668 21.2916 25.6668C20.2561 25.6668 19.4166 24.8563 19.4166 23.8565C19.4166 22.8567 20.2561 22.0462 21.2916 22.0462C22.3272 22.0462 23.1666 22.8567 23.1666 23.8565Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};

export const CartFilled: React.FC<IconExportsProps> = ({
  color,
}: IconExportsProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.17774 4.57334H4.35725L8.10277 20.1747C8.21975 20.662 8.60935 21 9.05395 21H20.8849C21.3373 21 21.7317 20.6502 21.8414 20.1516L24.4705 8.20498C24.5441 7.87039 24.478 7.51592 24.2911 7.24408C24.1043 6.97224 23.8176 6.81334 23.514 6.81334H6.93887L6.06146 3.15865C5.94448 2.67138 5.55489 2.33334 5.11029 2.33334H2.17774C1.61932 2.33334 1.16663 2.83478 1.16663 3.45334C1.16663 4.0719 1.61932 4.57334 2.17774 4.57334ZM8.87496 25.6668C9.91049 25.6668 10.75 24.8563 10.75 23.8565C10.75 22.8567 9.91049 22.0462 8.87496 22.0462C7.83942 22.0462 6.99996 22.8567 6.99996 23.8565C6.99996 24.8563 7.83942 25.6668 8.87496 25.6668ZM23.1666 23.8565C23.1666 24.8563 22.3272 25.6668 21.2916 25.6668C20.2561 25.6668 19.4166 24.8563 19.4166 23.8565C19.4166 22.8567 20.2561 22.0462 21.2916 22.0462C22.3272 22.0462 23.1666 22.8567 23.1666 23.8565Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};

export const CouponOutline: React.FC<IconExportsProps> = ({
  color,
}: IconExportsProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 11.6667C16.8557 11.6667 16.3334 12.189 16.3334 12.8333V15.1667C16.3334 15.811 16.8557 16.3333 17.5 16.3333C18.1444 16.3333 18.6667 15.811 18.6667 15.1667V12.8333C18.6667 12.189 18.1444 11.6667 17.5 11.6667Z"
        fill={color || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66671 4.66666C3.37804 4.66666 2.33337 5.71133 2.33337 6.99999V11.6667C2.33337 12.311 2.85571 12.8333 3.50004 12.8333C4.14437 12.8333 4.66671 13.3557 4.66671 14C4.66671 14.6443 4.14437 15.1667 3.50004 15.1667C2.85571 15.1667 2.33337 15.689 2.33337 16.3333V21C2.33337 22.2887 3.37804 23.3333 4.66671 23.3333H23.3334C24.622 23.3333 25.6667 22.2887 25.6667 21V16.3333C25.6667 15.689 25.1444 15.1667 24.5 15.1667C23.8557 15.1667 23.3334 14.6443 23.3334 14C23.3334 13.3557 23.8557 12.8333 24.5 12.8333C25.1444 12.8333 25.6667 12.311 25.6667 11.6667V6.99999C25.6667 5.71133 24.622 4.66666 23.3334 4.66666H4.66671ZM18.6667 6.99999H23.3334V10.6991C21.974 11.1796 21 12.4761 21 14C21 15.5239 21.974 16.8204 23.3334 17.3008V21H18.6667V19.8333C18.6667 19.189 18.1444 18.6667 17.5 18.6667C16.8557 18.6667 16.3334 19.189 16.3334 19.8333V21H4.66671V17.3008C6.0261 16.8204 7.00004 15.5239 7.00004 14C7.00004 12.4761 6.0261 11.1796 4.66671 10.6991V6.99999L16.3334 6.99999V8.16666C16.3334 8.81099 16.8557 9.33332 17.5 9.33332C18.1444 9.33332 18.6667 8.81099 18.6667 8.16666V6.99999Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};

export const CouponFilled: React.FC<IconExportsProps> = ({
  color,
}: IconExportsProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33337 6.99996C2.33337 5.7113 3.37804 4.66663 4.66671 4.66663H23.3334C24.622 4.66663 25.6667 5.7113 25.6667 6.99996V11.6666C25.6667 12.311 25.1444 12.8333 24.5 12.8333C23.8557 12.8333 23.3334 13.3556 23.3334 14C23.3334 14.6443 23.8557 15.1666 24.5 15.1666C25.1444 15.1666 25.6667 15.689 25.6667 16.3333V21C25.6667 22.2886 24.622 23.3333 23.3334 23.3333H4.66671C3.37804 23.3333 2.33337 22.2886 2.33337 21V16.3333C2.33337 15.689 2.85571 15.1666 3.50004 15.1666C4.14437 15.1666 4.66671 14.6443 4.66671 14C4.66671 13.3556 4.14437 12.8333 3.50004 12.8333C2.85571 12.8333 2.33337 12.311 2.33337 11.6666V6.99996ZM16.3334 8.16667V7H18.6667V8.16667C18.6667 8.811 18.1444 9.33333 17.5 9.33333C16.8557 9.33333 16.3334 8.811 16.3334 8.16667ZM18.6667 19.8333V21H16.3334V19.8333C16.3334 19.189 16.8557 18.6667 17.5 18.6667C18.1444 18.6667 18.6667 19.189 18.6667 19.8333ZM17.5 11.6666C16.8557 11.6666 16.3334 12.189 16.3334 12.8333V15.1666C16.3334 15.811 16.8557 16.3333 17.5 16.3333C18.1444 16.3333 18.6667 15.811 18.6667 15.1666V12.8333C18.6667 12.189 18.1444 11.6666 17.5 11.6666Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};
